module.exports = __webpack_public_path__ + "static/media/badge-cia-novo-roxo.e54346c1.png";